// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2idkO","col":"styles_col__3qc9A"};